import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';

const questionnaire1 = [{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 1,
    question: '¿Qué es el manejo a la defensiva?',
    answers: [
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Es conducir evitando tener accidentes, a pesar de las acciones incorrectas de los demás conductores y de las condiciones climáticas o físicas de las carreteras.',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Es salir a manejar confiando en nuestras destrezas sin importar el destino.',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Es protegerse con dispositivos especiales electrónicos que nos ayudan a prevenir accidentes.'
        }
    ]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 2,
    question: '¿Cuáles son las etapas para evitar un accidente de tránsito?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Valorar la situación, ir atento a lo que se presente y hacer uso de la bocina.',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Reconocer el peligro y aplicar las acciones pertinentes, para evitarlo y actuar de inmediato.',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Conservar la calma y decidir lo más pronto posible.'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 3,
    question: 'Gustavo se encuentra circulando por una carretera y a lo lejos observa que los vehículos se van deteniendo debido a la lluvia. ¿Qué debe hacer para evitar un accidente vial?',
    answers: [
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Reducir su velocidad y activar sus intermitentes',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Activar sus direccionales',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Usar el cinturón de seguridad'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 4,
    question: '¿Los accidentes de tránsito son evitables?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'No, porque dependen de muchos factores',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'No, ya que dependen del azar o la suerte ',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Si, porque se debe conducir siempre a la defensiva'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 5,
    question: 'El retrovisor lateral de su unidad esta roto y decide NO cambiarlo ¿Cuál es el mayor riesgo de usarlo así?',
    answers: [

        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Dar mala imagen a tu vehículo, pues se ve descuidado',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Altera la visibilidad y genera puntos ciegos',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Conseguir una multa porque está prohibido conducir así '
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 6,
    question: '¿Con que elemento de seguridad se consigue reducir en buena medida, el impacto del conductor contra las estructuras rígidas del interior del tractocamión y su proyección fuera de la cabina en caso de un accidente?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Con la instalación de frenos ABS',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Con la instalación del control de tracción ASR',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Con la instalación y uso del cinturón de seguridad'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 7,
    question: '¿Cuál es el dispositivo de seguridad que debes usar para hacerte visible en caso de una emergencia en carretera?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Uniforme de seguridad',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Triángulos de prevención',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Chaleco antirreflejante'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 8,
    question: '¿Cómo se puede definir la velocidad adecuada?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Velocidad no adaptada a las condiciones climatológicas o a las circunstancias de la vía ',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Velocidad que nos permite una amplia garantía de estar en condiciones, de controlar o detener el vehículo ante cualquier obstáculo',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Límite superior de velocidad permitido para la vía por la que circulamos'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 9,
    question: '¿A qué se denomina distancia de frenado?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'A la que recorre el vehículo desde que se percibe el peligro, hasta que se acciona el pedal del freno.',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'A la que recorre el vehículo desde que se pisa el freno, hasta que se detiene el vehículo.',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'A la distancia que nos separa del vehículo que circula frente a nosotros.'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 10,
    question: '¿Cuál es la velocidad máxima a la que debes circular en las carreteras?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Velocidad no adaptada a las condiciones climatológicas o a las circunstancias de la vía',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Velocidad que indiquen los señalamientos viales en la carretera.',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Conduciendo 20 Km por debajo del límite superior de velocidad, permitido para la vía por la que circulemos.'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 11,
    question: '¿A qué altura debe de ajustarse la parte superior del posa cabezas en el tractocamión?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Por encima de la parte posterior de la cabeza',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Por debajo de la nuca del conductor',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'A la misma altura que la parte superior de la cabeza'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 12,
    question: 'Es un ejemplo de aplicación de manejo a la defensiva:',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Juan realiza una vuelta prohibida, activando sus direccionales.',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'El semáforo tenía luz roja y Juan se paso el alto teniendo precaución antes de cruzar para no atropellar a ningún peatón.',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'El vehículo de adelante giro a la derecha sin accionar sus direccionales, pero Juan tenía suficiente distancia para evitar un accidente.'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 13,
    question: '¿Qué se debe hacer tras una gran discusión?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Tomar la unidad para tranquilizarse conduciendo',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Esperar a tranquilizarse para conducir el tracto y emprender el viaje',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Continuar con la discusión con el manos libres mientras se conduce'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 14,
    question: 'Hay un solo carril en su dirección y el vehículo delante de usted frecuentemente disminuye la velocidad sin razón aparente , bajo esta situación usted debe:',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Acelerar para pasar al vehículo lo más pronto posible',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Aumentar la distancia de separación entre usted y el vehículo',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Hacer relampaguear rápidamente las luces delanteras para alertar al otro vehículo'
        }]

},
{
    image: '',
    exam_id: 1,
    question_type: 1,
    question_id: 15,
    question: 'Son las causas más frecuentes que originan un accidente.',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'El ruido, el clima, la licencia de conducir.',
        },
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Distracciones, agresividad, exceso de confianza y falta de pericia al manejar.',
        },
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'La Conciencia, la razón, la justicia.'
        }]

}]

//maniobra espacio reducido 
const questionnaire2 = [{
    image: '',
    exam_id: 2,
    question_type: 1,
    question_id: 1,
    question: '¿Cuáles son las causas más comunes que pueden provocar un accidente, cuando realiza maniobras en un espacio reducido?'
    , answers: [
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'No dimensionar el lugar de la maniobra en 360°, distracciones y no bajar del vehículo para verificar los espacios.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'El estado de ánimo, la comunicación con el monitorista y el celular.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'El trabajo en equipo, el clima, el peatón y los árboles.'
        }]
},
{
    image: '',
    exam_id: 2,
    question_type: 1,
    question_id: 2,
    question: 'Se define como: la operación realizada por un vehículo, que interrumpe el movimiento normal de sí mismo dentro de la corriente circulatoria, para el acomodo del remolque en un espacio determinado.'
    , answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Arrastre',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Detención',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Maniobra'
        }]
},
{
    image: '',
    exam_id: 2,
    question_type: 1,
    question_id: 3,
    question: 'Se define como un espacio reducido.'
    , answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Es la conducta agresiva que permite delimitar el espacio entre un vehículo y otro. ',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Implica mantener un espacio de seguridad entre nuestro vehículo y los demás usuarios viales.',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Es aquel espacio que tiene áreas de entrada o salida, pero limitados y/o restringidos.'
        }]
},
{
    image: '',
    exam_id: 2,
    question_type: 1,
    question_id: 4,
    question: 'Son algunas características de la actitud preventiva.'
    , answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Falta de pericia al manejar, actitud negativa.',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Inspección y preparación del equipo, aplicar técnicas de manejo a la defensiva, tomar medidas de seguridad.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Agresividad, rapidez y poca tolerancia.'
        }]
},
{
    image: '',
    exam_id: 2,
    question_type: 1,
    question_id: 5,
    question: 'Son todas aquellas áreas o zonas cercanas al vehículo, que no pueden ser correctamente observadas por el conductor:'
    , answers: [
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Puntos ciegos',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Zona de descarga ',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Puntos de seguridad '
        }]
},
{
    image: 'static/blind.png',
    exam_id: 2,
    question_type: 1,
    question_id: 6,
    question: 'Señala cuáles son los puntos ciegos durante la conducción: ',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'a)',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'b)',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'c)'
        }]
}]

//MANTENIMIENTO BÁSICO
const questionnaire3 = [
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 1,
        question: 'Indica cual es el mejor momento para realizar la revisión de presión y condiciones de tus neumáticos:',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '2 o 3 veces durante el viaje',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Al término del viaje',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Al inicio del viaje'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 2,
        question: 'Al revisar la presión de tus llantas, ¿Cuáles son los factores que tomas en cuenta para asegurar que la presión es correcta y que esta no tenga variaciones durante el viaje?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Poner a 100 lbs/psi en ejes delanteros y 95lbs/psi en llantas de ejes traseros y revisar la presión varias veces durante el trayecto del viaje.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Validar que la válvula del rin se encuentre en buenas condiciones y con el tapón, que el neumático se encuentre frío, que la presión del neumático sea la recomendada por el fabricante o el área de mantenimiento y asegurarse que el pivote quede en posición correcta al término de la revisión.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Golpear los neumáticos tratando de identificar por medio del sonido, bajas presiones o ponchaduras, poner aire en la llanta que identifiquemos a través del sonido que le falta aire.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 3,
        question: 'Al inspeccionar los neumáticos en la unidad ¿Qué condiciones revisas para asegurarte que éstos se encuentren en buen estado?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Que tenga dibujo el piso, sin desgastes irregulares, sin protuberancias en caras de la llanta, el rin sin golpes y que no tengan objetos incrustados o secciones arrancadas en el piso.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Que sean llantas nuevas en todas las posiciones, que sean marcas reconocidas, que los rines sean de aluminio',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Es mejor no revisar las llantas, reportar el área de mantenimiento su inspección cada vez que lo ingrese a taller, para que personal calificado las verifique y se asegure que todo está en condiciones de uso.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 4,
        question: 'Antes de encender la unidad ¿Qué elementos debes revisar o tomar en cuenta para asegurarte que no dañaras el motor?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Al abrir el switch en primer paso, que haga el recorrido de sensores completo, que en la pantalla no indique códigos de falla, que los instrumentos realicen su recorrido de agujas y que la transmisión este en neutral.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Revisar los niveles de fluido del motor, que las bandas del motor no estén dañadas y que no existan señales de fugas de fluidos en piso o en motor.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Preguntar al taller si tiene algún reporte mecánico, preguntar al supervisor de tráfico si el operador anterior reporto alguna falla.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 5,
        question: 'En tu experiencia como operador ¿De cuántos tiempos han sido los motores a diésel que has manejado?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 4 tiempos',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 3 tiempos',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 5 tiempos'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 6,
        question: 'En los motores a diésel ¿Cuál es el rango de temperatura correcta que debe de tener el anticongelante, durante la operación de la unidad?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 90 a 100 °C',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 75 a 85 °C ',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'DE 85 a 93 °C'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 7,
        question: 'En un motor ISX ¿Cuál es la presión de aceite óptima que debe marcar tu indicador en el tablero, cuando el motor alcanzó su temperatura de funcionamiento óptimo, en libras por pulgada cuadrada PSI?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 35 a 40 psi',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 20 a 25 psi',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 42 a 47 psi'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 8,
        question: '¿Cuál es la función del turbo cargador en un motor a diésel?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Dar mayor potencia a la transmisión, para subir más fácilmente en pendientes.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Ingresar más aire a la cámara de combustión, para mejorarla.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Dar mayor velocidad a la unidad al presionar más el acelerador.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 9,
        question: 'Para mejorar el rendimiento de combustible en un motor a diésel DD15, ¿En qué rangos de operación debes de realizar y mantener tus RPM, durante los cambios de velocidad ?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 1500 a 1800 rpm.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 1100 a 1450 rpm.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 1300 a 1600 rpm.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 10,
        question: 'En un sistema neumático de frenos de potencia, ¿Cuáles son las condiciones principales que tienes que revisar?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Que los indicadores registren adecuadamente la presión de aire y que no escuches alguna fuga.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Rotochambers, balatas y matracas',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Pedal de frenos, secador de aire y válvulas repartidoras.  '
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 11,
        question: 'En las unidades de servicio pesado (tractores o camiones), ¿Cuál es la presión que debe de marcar el indicador en el tablero, para que los frenos y otros accesorios que requieren aire , funcionen adecuadamente? ',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '70 a 75 psi.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '98 a 120 psi.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: '85 a 100 psi.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 12,
        question: 'En condiciones normales de conducción, el freno de motor ¿En que rangos de RPM debe ser usado?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 1500 a 1900 rpm.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 1300 a 1450 rpm.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 1750 a 2200 rpm.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 13,
        question: 'El uso constante de los frenos de servicio en una pendiente, ¿Qué consecuencias ocasiona en su funcionamiento?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Mejora el control de la velocidad.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Calienta las balatas y tambores.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Produce más presión de aire que ayuda a mejorar el frenado.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 14,
        question: '¿Qué condiciones afectan el funcionamiento de los frenos ABS y antibloqueo, en un frenado brusco?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Que los neumáticos en el tractor sean de diferentes medidas.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Que el piso este mojado y este lloviendo.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Traer el freno de motor activado.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 15,
        question: 'En el sistema eléctrico de 12volts en una unidad de servicio pesado, ¿Cuál es la lectura correcta que debe de tener tu voltímetro, para asegurar que tus baterías no tienen ningún problema?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 12 a 13.5 volts.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 10.5 a 12 volts.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 13.5 a 14 volts.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 16,
        question: 'El medidor de restricción de aire que está en el panel de instrumentos de la unidad, ¿Qué función tiene y que te ayuda a identificar?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Que el filtro del aire de motor está en condiciones de uso correcto o incorrecto.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Que el filtro del secador de aire está en condiciones de uso correcto o incorrecto.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Que el paso del aire a la transmisión es correcta o incorrecta.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 17,
        question: '¿Cuál es la temperatura que no pueden exceder los aceites de la transmisión y diferenciales, durante la conducción en pendientes y con carga pesada?  ',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '200 °F',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: '250 °F',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '300 °F'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 18,
        question: 'En un tractor que cuenta con una transmisión automática, ¿Qué función debes de realizar antes de encender o apagar la unidad?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Colocar la palanca selectora de velocidad en posición de neutral.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Presionar el pedal del embrague, para asegurar que tenga el juego correcto.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Revisar la presión de aire en el sistema neumático y que este aplicado el freno de estacionamiento.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 19,
        question: 'La mayor parte de los motores a diésel tienen un sistema de apagado automático, configurado para apagar el motor a los 5 minutos después de que la unidad se detiene.  ¿Esta configuración en que ayuda al motor?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Para disminuir el gasto de diésel y mantener un rendimiento promedio mayor',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Para apagarlo y que no se caliente el agua y el aceite del motor por uso constante',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Para permitir que el motor y turbo desaceleren y al apagarse estén con la lubricación correcta.'
            }]
    },
    {
        image: '',
        exam_id: 3,
        question_type: 1,
        question_id: 20,
        question: 'En las unidades que funcionan mediante módulos electrónicos ¿Por qué no debes de realizar ningún tipo de instalación eléctrica?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Por qué puedes dañar la instalación, que además de energía lleva datos que son importantes para el funcionamiento de los módulos.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Por qué puedes dañar las baterías, las cuales no están diseñadas para soportar el funcionamiento de componentes electrónicos adicionales.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Las dos respuesta anteriores son correctas.'
            }
        ]
    }
]

//protocolos de seguridad
const questionnaire4 = [{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 1,
    question: 'Antes de iniciar un viaje, debo asegurarme del buen funcionamiento de:',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'El estéreo, la antena de señal, la limpieza de los tapetes.',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'El buen funcionamiento de: tractor, remolque(S), dolly, neumáticos y teléfono celular,',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'La amplitud del camarote, el tipo de rines de los neumáticos, el color de la pintura del tractocamión.'
        }
    ]
},
{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 2,
    question: '¿Cuáles son algunos de los documentos indispensables que debo portar antes de iniciar mi viaje?',
    answers: [
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Tarjeta de circulación cotejada, verificaciones, placas y engomado vigente, certificado de baja emisión de contaminantes, certificado de condiciones físico-mecánica.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Póliza de seguro de daños a terceros, factura del tractocamión, calcomanías de no fumar.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Mi licencia de conducir, factura del remolque, acta de nacimiento, CURP.'
        }
    ]
},
{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 3,
    question: '¿En qué consiste el circulo de servicio en TUMSA, para poder cuidar tu integridad, la de la mercancía y la del equipo que conduces?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'En brindar atención al cliente.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Llegar a tiempo a mis entregas.',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Reportar todos mis movimientos al área de Monitoreo TUMSA como: inicio de viaje, cualquier detención que realice, reinicio de viaje, llegada a cliente, ingreso a descarga, fin de descarga y fin de viaje.'
        }
    ]
},
{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 4,
    question: 'Si durante mi viaje se presentará algún problema como: cierre carretero o desviaciones de ruta, ponchadura de neumático, enfermedad o malestar, cansancio extremo ¿A quién debo de informar de inmediato para recibir auxilio o instrucciones?',
    answers: [
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Área de Monitoreo de TUMSA',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Al dueño de la mercancía que este trasladando.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'A nadie, puedo tomar la decisión que considere adecuada.'
        }

    ]
},


{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 5,
    question: 'Jorge se encuentra vacío en espera de asignación de viaje y pretende ir a su domicilio utilizando el tractocamión ¿Que debe hacer?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Solicitar autorización al Supervisor de Trafico.',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Dar aviso al área de Monitoreo TUMSA, resguardar la unidad en La Base más cercana o pensión autorizada, solicitar el paro de motor y trasladarse por sus propios medios a su domicilio.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'No avisar a nadie y llevarme la unidad a mi domicilio.'
        }
    ]
},
{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 6,
    question: '¿Cuántos acompañantes puedo llevar en mi unidad?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Solo uno.',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Ninguno, en TUMSA está totalmente llevar acompañantes.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Dos acompañantes.'
        }
    ]
},
{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 7,
    question: '¿Cuál es la velocidad máxima permitida en TUMSA?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: '120 kilómetros por hora.',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: '70 kilómetros por hora o 20 kilómetros por debajo de lo que indican los señalamientos viales.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: '90 kilómetros por hora.'
        }
    ]
},
{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 8,
    question: '¿Cuál es la consecuencia de NO acatar, las medidas de seguridad dentro de las instalaciones del cliente?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Ninguna, mi patrón es TUMSA.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Que no me descarguen a tiempo.',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Corro el riesgo de que me boletinen y no podré realizar más ninguno de sus servicios, por lo tanto procederá mi baja sin responsabilidad para TUMSA.'
        }
    ]
},
{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 9,
    question: '¿Por qué debo realizar el llenado de mi bitácora de horas de servicio en cada viaje?',
    answers: [
        {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Porque me lo pide mi Supervisor para asignarme el siguiente viaje.',
        }, {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Porque es un requisito legal y al no cumplirlo seré infraccionado por las autoridades. Además, es un documento que obligatoriamente tengo que entregar en TUMSA, al momento de mi liquidación para poder cobrar mi servicio.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: ' No es necesario llenarla, no sirve para nada'
        }
    ]
},
{
    image: '',
    exam_id: 4,
    question_type: 1,
    question_id: 10,
    question: '¿Qué consecuencia tiene el no cumplir con los lineamientos del reglamento interno de TUMSA?',
    answers: [
        {
            is_answer: true,
            answer_image: '',
            answer_if_text: '',
            answer: 'Seré sujeto a sanciones que pueden incluir mi recisión de contrato.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'No tendré carta de recomendación por no ser responsable.',
        }, {
            is_answer: false,
            answer_image: '',
            answer_if_text: '',
            answer: 'Ninguna.'
        }
    ]
}]

//reglamento de transito
const questionnaire5 = [
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 1,
        question: '¿Cuáles son los documentos que todo vehículo debe portar, para circular en las carreteras del territorio Nacional?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Tarjeta de circulación, placas y calcomanías de circulación vigentes: físico mecánicas y no contaminantes.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Tarjeta de circulación, identificación de conductor, dirección de entrega.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Calcomanías de circulación vigentes: físico mecánicas, factura del tractocamión, CURP del operador.'
            }
        ]
    },
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 2,
        question: '¿Qué tipos de faltas al reglamento de tránsito durante tu conducción, podrían hacerte acreedor a infracciones, confiscación de licencia, tarjeta de circulación o placa?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Abandonar la unidad después de un accidente, conducir en estado de ebriedad, posesión de estupefacientes, traslado de inmigrantes.',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'No utilizar el cinturón de seguridad, circular por carriles centrales en zonas urbanas, uso del teléfono celular mientras conduces, tener vidrios polarizados.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Traslado de inmigrantes, estado de ebriedad, no utilizar el cinturón de seguridad, no portar licencia de conducción.'
            }
        ]
    },
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 3,
        question: '¿Cuál es el tipo de licencias requeridas para operar tractocamión y torthon?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Licencia tipo B y C',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Licencia tipo B',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Licencia tipo A'
            }]
    },
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 4,
        question: 'Jorge es detenido en un retén de pesos y dimensiones, para una revisión de rutina. El oficial le informa que tendrá que multarlo y consignar el equipo, porque excede el largo permitido para circular por ese tipo de carretera. ¿Qué debe hacer Jorge ante esta situación?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Jorge debe aceptar la multa ya que el largo del equipo rebasa lo permitido.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Jorge debe negarse porque el vehículo no excede las dimensiones.',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Jorge debe reportar al área de monitoreo, la detención desde el momento en que suceda y no aceptar o firmar ningún documento, hasta recibir las instrucciones del gestor que le asignen.'
            }]
    },
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 5,
        question: 'Manuel se percata de que la placa del remolque que trasladará está dañada, los últimos 2 números no se distinguen. Durante su viaje es detenido por las autoridades. De acuerdo con el reglamento de tránsito ¿Cuáles serían las consecuencias?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Ser sancionado porque no cumple con el reglamento de tránsito.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'No pueden sancionarlo ya que solo es parcial la falta de placa.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'No pueden sancionarlo porque tiene tarjeta de circulación y engomado vigentes.'
            }]
    },
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 6,
        question: 'Cual es el horario permitido al transporte de carga, para circular en zonas metropolitanas y el valle de México.',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 8 a.m. a las 10 a.m. y de 15:00 a 20:00 de lunes a viernes.',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 6 a.m. a las 10 a.m. y de 18:00 a 20:00 de lunes a viernes.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'De 7 a.m. a las 11 a.m. y de 18:00 a 20:00 de lunes a viernes.'
            }]
    },
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 7,
        question: 'Cesar es detenido por la guardia nacional para realizar la revisión de su bitácora de horas de servicio. Al recibirla el oficial se da cuenta de que los datos solicitados en el formato no están completos. De acuerdo con el reglamento de tránsito ¿Cuáles serán las consecuencias?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'No pueden sancionarlo ya que solo está omitiendo datos.',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Si pueden sancionarlo porque está omitiendo datos.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'No tiene la obligación de mostrarles la bitácora, porque no es un requisito realizarla.'
            }]
    },
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 8,
        question: ' En todo tipo de carreteras ¿Cuál es el carril asignado para el transito del transporte de carga?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: ' Derecha',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: ' Izquierda',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: ' Ambas'
            }]
    },
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 9,
        question: '¿En qué casos el transporte de carga puede circular por el carril izquierdo?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'En todo momento',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Exclusivamente para realizar rebases',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Nunca'
            }]

    },
    {
        image: '',
        exam_id: 5,
        question_type: 1,
        question_id: 10,
        question: '¿Qué tipos de faltas al reglamento de tránsito durante tu conducción, podrían ocasionar la privación de tu libertad y consignación del tractocamión?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Hablar por el teléfono celular mientras conduces, no portar la tarjeta de circulación, posesión de estupefacientes, no utilizar el cinturón de seguridad.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Conducir a exceso de velocidad, abandonar la unidad después de un accidente, tener los vidrios polarizados, conducir sin licencia, no utilizar el cinturón de seguridad.',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Abandonar la unidad después de un accidente, conducir en estado de ebriedad, posesión de estupefacientes, traslado de inmigrantes.'
            }]
    }
]

//Señalamientos Viales
const questionnaire6 = [
    {
        image: '',
        exam_id: 6,
        question_type: 1,
        question_id: 1,
        question: '¿Cuáles son los 3 tipos de señalamientos viales?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Señalamientos: preventivos, restrictivos e informativos.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Señalamientos: informativos, restringentes y tránsito.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Señalamientos: restrictivos, tránsito y turísticos.'
            }
        ]
    },
    {
        image: '',
        exam_id: 6,
        question_type: 1,
        question_id: 2,
        question: '¿Cuáles son señalamientos preventivos?',
        answers: [
            {
                is_answer: true,
                answer_image: 'static/16.jpg',
                answer_if_text: '',
                answer: 'a)'
            },
            {
                is_answer: false,
                answer_image: 'static/17.jpg',
                answer_if_text: '',
                answer: 'b)'
            },
            {
                is_answer: false,
                answer_image: 'static/18.jpg',
                answer_if_text: '',
                answer: 'c)'
            }
        ]
    },
    {
        image: '',
        exam_id: 6,
        question_type: 1,
        question_id: 3,
        question: '¿Cuáles son señales restrictivas?',
        answers: [
            {
                is_answer: false,
                answer_image: 'static/19.jpg',
                answer_if_text: '',
                answer: 'a)'
            },
            {
                is_answer: true,
                answer_image: 'static/20.jpg',
                answer_if_text: '',
                answer: 'b)'
            },
            {
                is_answer: false,
                answer_image: 'static/18.jpg',
                answer_if_text: '',
                answer: 'c)'
            }
        ]
    },
    {
        image: '',
        exam_id: 6,
        question_type: 1,
        question_id: 4,
        question: '¿Cuáles son los señalamientos, que contienen leyendas o símbolos cuyo objetivo es guiar y orientar al usuario a lo largo de su recorrido por las carreteras ?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Señalamientos de conocimiento'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Señalamientos restrictivos'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Señalamientos informativos'
            }
        ]
    },
    {
        image: '',
        exam_id: 6,
        question_type: 1,
        question_id: 5,
        question: '¿Qué color se utiliza para los señalamientos restrictivos?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Amarillo'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Color blanco y aro de color rojo'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Verde'
            }
        ]
    },
    {
        image: '',
        exam_id: 6,
        question_type: 4,
        question_id: 6,
        question: 'Relaciona de forma correcta los señalamientos viales',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'a',
                answer: 'Superficie deslizante'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'b',
                answer: 'Límite máximo de velocidad'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'c',
                answer: 'Curva'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'd',
                answer: 'Prohibido el paso de vehículos pesados'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'e',
                answer: 'Incorporación de tránsito'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'f',
                answer: 'Gasolinera'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'g',
                answer: 'Vuelta prohibida en U'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'h',
                answer: 'Cruce de escolares'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'i',
                answer: 'Conserve su derecha'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'j',
                answer: 'Prohibido retorno'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'k',
                answer: 'Doble circulación'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'l',
                answer: 'Camino sinuoso'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'm',
                answer: 'Entronque en delta'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'n',
                answer: 'Puente angosto'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: 'o',
                answer: 'No parar'
            },
            {
                is_answer: false,
                answer_image: 'static/05.jpg',
                answer_if_text: 'a',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/07.jpg',
                answer_if_text: 'b',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/08.jpg',
                answer_if_text: 'c',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/01.jpg',
                answer_if_text: 'd',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/10.jpg',
                answer_if_text: 'e',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/04.jpg',
                answer_if_text: 'f',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/09.jpg',
                answer_if_text: 'g',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/03.jpg',
                answer_if_text: 'h',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/06.jpg',
                answer_if_text: 'i',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/02.jpg',
                answer_if_text: 'j',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/15.jpg',
                answer_if_text: 'k',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/13.jpg',
                answer_if_text: 'l',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/11.jpg',
                answer_if_text: 'm',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/12.jpg',
                answer_if_text: 'n',
                answer: ''
            },
            {
                is_answer: false,
                answer_image: 'static/14.jpg',
                answer_if_text: 'o',
                answer: ''
            }

        ]
    }

]

//reconocimiento de ruta
const questionnaire7 = [
    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 1,
        question: 'Saliendo de Cuautitlán Estado de México ¿Cuál es el orden de las casetas que debes cruzar, circulando por carreteras de peaje, para llegar a la ciudad de Oaxaca?',

        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Mexiquense, Palmillas, Fortín, Cuitláhuac, paso del toro.',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Circuito Exterior Mexiquense, San Marcos, San Martín Texmelucan, Puente elevado Puebla, Amozoc, Tehuacán, Nochixtlán, Huitzo, Oaxaca.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Circuito Exterior Mexiquense, San Marcos, Amozoc II , Perote, Nochixtlán, Tehuacán, Huitzo, Oaxaca.'
            }]
    },

    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 2,
        question: 'Daniel se encuentra cargando en un CEDIS en Tepeji (Estado de México) , el destino de su viaje es el estado de Chihuahua ¿Cuántas horas en promedio estará conduciendo Daniel?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '23 horas',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '12 horas',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: '16 horas'
            }]
    },

    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 3,
        question: 'En el tramo de Salina Cruz a Huatulco ¿Qué dimensión de remolque tiene permitido circular?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Remolque de 40´´',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Remolque de 53´´',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Remolque de 48´´'
            }]

    },
    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 4,
        question: 'Saliendo de San Martín Obispo, Estado de México ¿Cuál es el orden de las casetas que debes cruzar, circulando por carreteras de peaje, para llegar al puerto de Veracruz?',

        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Circuito Exterior Mexiquense, San Marcos, San Martín Texmelucan, Puente elevado Puebla, Amozoc, la Esperanza, Fortín, Cuitláhuac, Paso del Toro.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Circuito Exterior Mexiquense, Puente elevado, Fortín, Cuitláhuac, San Martín Texmelucan, Paso del toro.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Tepotzotlán, Palmillas, Chichimequillas, Fortín, Cuitláhuac, Paso del Toro.'
            }]
    },

    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 5,
        question: 'En el tramo de Acapulco Pinotepa Nacional ¿Qué dimensión de remolque tiene permitido circular?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Remolque de 53´´',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Remolque de 40´´',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Remolque de 48´´'
            }]

    },
    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 6,
        question: 'Carlos es un operador de tractocamión, él no puede circular por carreteras libres y tiene que realizar un viaje de San Marín Obispo (Estado de México) con dirección a Guadalajara ¿Qué ruta debe tomar Carlos?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Tepotzotlán, Palmillas, Querétaro, Cerro Gordo, León, Jalostotitlán, Tepatitlán, La Joya o Zapotlanejo.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Circuito Exterior Mexiquense, San Marcos, San Martín Texmelucan, Puente elevado Puebla, Amozoc.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Tepotzotlán, Palmillas, Chichimequillas, Los Chorros, León, Jalostotitlán, Tepatitlán, La Joya.'
            }]
    },


    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 7,
        question: 'El operador Fernando se encuentra cargando en el complejo en Torreón, su destino es un CEDIS en Puebla ¿Cuántos kilómetros recorrerá Fernando en su viaje?',

        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: '1120 Km',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '1300 Km',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '980 Km'
            }]

    },
    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 8,
        question: 'Josué tiene un viaje asignado que inicia en el Estado de México y concluye en la Cd. de Monterrey, ¿cuál es la ruta que tomará, si tiene que circular por carreteras de peaje?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Circuito Exterior Mexiquense, San Marcos, San Martín Texmelucan, Puente elevado Puebla, Amozoc.',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Tepotzotlán, Palmillas, Chichimequillas, San Luis, Matehuala, Los chorros, La carbonera, ojo caliente, saltillo.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Tepotzotlán, Palmillas, Querétaro, Cerro Gordo, León, La carbonera, Saltillo.'
            }]

    },

    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 9,
        question: 'Pablo realizará un viaje saliendo de san Martín Obispo (Estado de México), su destino es Acapulco ¿Cuántas horas conducirá Pablo durante su servicio?',

        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '14 horas',
            }, {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: '6 horas',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '9 horas'
            }]

    },
    {
        image: '',
        exam_id: 7,
        question_type: 1,
        question_id: 10,
        question: 'Alejandro tiene un viaje asignado en doble remolque, del centro de Villa Hermosa con dirección a la Cd. De Cancún, transitando por carreteras de peaje ¿Qué casetas tiene que cruzar?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Nacajuca, Zacatal, Isla Aguada, Seybaplaya, Valladolid, Cancún.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Nacajuca, Zacatal, Isla Aguada, Escárcega, Chablé, Cancún.',
            }, {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Libramiento Villa Hermosa, Isla Aguada, Nacajuca, Puente Grijalva, Cancún. '
            }]
    }
]

// medidas de seguridad//MEDIDAS DE SEGURIDAD EN PROCESO DE CARGA Y DESCARGA
const questionnaire8 = [
    {
        image: '',
        exam_id: 8,
        question_type: 1,
        question_id: 1,
        question: '¿Qué podría suceder si el remolque estuviera demasiado alto cuando usted tratara de enganchar?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: '	El perno rey no encaja en la quinta y no ocurre el enganche, si el perno pega en la quinta corre el riesgo de dañarla.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '	El perno rey encaja en la quinta y ocurre un enganche totalmente seguro'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '	Se podrían vencer los patines del remolque y se corre el riesgo de dañar la quinta.'
            }
        ]
    },
    {
        image: '',
        exam_id: 8,
        question_type: 2,
        question_id: 1,
        question: 'De los siguientes enunciados, indique cuales deben ser considerados para realizar un enganche seguro:',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Verificar que la quinta rueda se encuentre debidamente lubricada',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Revisar las bandas impulsoras',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Verificar que las muelas de la quinta rueda tengan la apertura correcta',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Verificar la altura del tractocamión y del semirremolque',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Ponchar las bolsas de aire',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Verificar que la unidad cuenta con el engomado de doble articulado.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Aproximar lentamente el tractor al, manteniéndolo alineado hasta que el acoplamiento se realice perfectamente.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Verificar que los limpiaparabrisas funcionen adecuadamente',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Desacoplar las mangueras del circuito neumático y las conexiones eléctricas.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Levantar los patines de apoyo de estacionamiento, verificando la colocación de la traba seguro.',
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Con los patines abajo realizar un tirón al remolque para asegurar el enganche.'
            }
        ]
    },
    {
        image: '',
        exam_id: 8,
        question_type: 5,
        question_id: 3,
        question: 'A continuación, ordene correctamente los pasos para realizar un desenganche seguro:',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '03',
                answer: 'Colocar las calzas',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '06',
                answer: 'Desacoplar las mangueras del circuito neumático y las conexiones eléctricas.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '05',
                answer: 'Jalar el gancho de la quinta rueda.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '08',
                answer: 'Retirar lentamente el vehículo tractor del semirremolque manteniéndolo alineado hasta quedar libre.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '01',
                answer: 'Procurar realizar la maniobra en un lugar adecuado es decir un terreno plano y compacto.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '07',
                answer: 'Ponchar las bolsas de aire.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '04',
                answer: 'Bajar los patines de apoyo de estacionamiento.',
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '02',
                answer: 'Accionar el freno de estacionamiento del tractor.'

            }
        ]
    },
    {
        image: '',
        exam_id: 8,
        question_type: 1,
        question_id: 1,
        question: '¿Por qué es importante colocar calzas en los neumáticos cuando las unidades estén estacionadas?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '	Para no conducir a exceso de velocidad durante el trayecto'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '	Para que la mercancía este sujetada correctamente'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: '	Para garantizar que la unidad se mantenga en su lugar y evitar accidentes'
            }
        ]
    },
    {
        image: '',
        exam_id: 8,
        question_type: 1,
        question_id: 1,
        question: '¿Cuál es la importancia de utilizar el tercer patín?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: '	Que el remolque de 28 pies no pierda su estabilidad durante la carga y descarga evitando que se levante.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '	Que el remolque de 53 pies no pierda su estabilidad durante la carga y descarga evitando que se levante.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: '	Que el remolque de 48 pies no pierda su estabilidad durante la carga y descarga evitando que se levante.'
            }
        ]
    }
]

//servicio al cliente
const questionnaire9 = [
    {
        image: '',
        exam_id: 9,
        question_type: 1,
        question_id: 1,
        question: '¿Qué es la calidad?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'La capacidad de ofrecer un producto o servicio, que pueda satisfacer las necesidades del cliente o usuario'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'La experiencia del negocio y  el valor real del producto'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Todas las anteriores'
            }
        ]
    },
    {
        image: '',
        exam_id: 9,
        question_type: 1,
        question_id: 1,
        question: 'Para lograr un buen resultado en la empresa, ¿Cómo operador de qué forma debes contribuir?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Dejando que los otros trabajen y solo manejar la unidad.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Trabajando en equipo con mis compañeros y seguir las indicaciones de la empresa.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Trabajando cómo a mí me guste y como estoy acostumbrado.'
            }
        ]
    },
    {
        image: '',
        exam_id: 9,
        question_type: 1,
        question_id: 1,
        question: '¿Cómo contribuyes para dar un buen servicio al cliente? ',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Con la  reducción de costos y la satisfacción del control de calidad en el producto.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Actuando con la aplicación del sistema logístico.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Realizando las entregas en el horario indicado por el cliente, respetando sus instrucciones y evitando cualquier situación que ponga en riesgo la mercancía. '
            }
        ]
    },
    {
        image: '',
        exam_id: 9,
        question_type: 1,
        question_id: 1,
        question: '¿Por qué es importante respetar los reglamentos internos de las instalaciones de nuestros clientes? ',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Para evitar que me llamen la atención y nos apliquen sanciones, que perjudiquen la imagen y la relación comercial entre las empresas. '
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Para evitar que te hagan salir de las instalaciones por faltas de respeto y te cobren una multa.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Lo mejor es no ingresar a las instalaciones de los clientes para evitar problemas.'
            }
        ]
    },
    {
        image: '',
        exam_id: 9,
        question_type: 1,
        question_id: 1,
        question: 'Alejandro al realizar una entrega,  se enfrenta con una reclamación por parte del cliente, quien  le culpa por daños que descubre en la mercancía que trasladaba y pretende regresársela ¿Cómo tiene que actuar Alejandro? ',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'No tiene que prestar atención a la reclamación del cliente, lo ignora y solo termina la entrega.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Escucha con atención la queja del cliente y amablemente le informa,  que reportara los hechos con su jefe para recibir instrucciones. Nunca tomara una decisión por el mismo.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Disgustado porque está cansado del viaje, escucha la reclamación del cliente porque no tiene opción. '
            }
        ]
    },
    {
        image: '',
        exam_id: 9,
        question_type: 1,
        question_id: 1,
        question: 'Si al estar realizando las maniobras para acomodar la unidad o el remolque en el andén o zona de descarga, accidentalmente dañas las instalaciones del cliente, otras unidades de arrastre o motrices estacionadas en el área ¿Cómo debes de actuar? ',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Si nadie noto el daño, termino la entrega y me retiro del lugar. '
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Si alguien nota el daño y me reclama el hecho, respondo que no fue mi culpa y me retiro del lugar.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Inmediatamente después de haber realizado accidentalmente el daño, me comunico al área de Monitoreo, para informarles de lo ocurrido y espero instrucciones del gestor que me asignen. '
            }
        ]
    },
    {
        image: '',
        exam_id: 9,
        question_type: 1,
        question_id: 1,
        question: 'Como parte de tus obligaciones y con el fin de agilizar el cobro de nuestro servicio, al concluir el viaje ¿Qué documentos obligatoriamente tienes que entregar a tu jefe?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Carta Porte de TUMSA firmada o sellada por el cliente, aceptando la realización del servicio; Facturas de gastos de maniobras, en caso de haber sido requeridas; Remisión que nos entrega el cliente como evidencia de haber solicitando el viaje, firmada  o sellada por parte del encargado que  recibe la entrega.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Apto médico del operador, factura simple de TUMSA, fotografía del lugar de la entrega, instrucciones de entrega,'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Certificado del seguro, carta porte de tumsa y recibos de gastos generados como parte de servicio, mapa del lugar de la entrega y la dirección exacta. '
            }
        ]
    },
    {
        image: '',
        exam_id: 9,
        question_type: 1,
        question_id: 1,
        question: 'El guardia de seguridad de cualquier cliente, te pide dinero o algún bien para agilizar tu ingreso y la carga de la unidad, esto con el fin de que no tengas que esperar tu turno y aproveches más el tiempo ¿Qué haces ante la propuesta del guardia? ',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Acepto la propuesta, porque es mínimo el monto solicitado en comparación con el beneficio que puedo lograr para la empresa, puesto que agilizare la carga y entrega de la mercancía y lograre un ahorro en tiempo y dinero.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Sin exaltarme, agradezco la oferta pero no la tomo. Porque la empresa en la que trabajo, se maneja bajo un Código de Ética y una Política de Integridad, que me comprometen a no incurrir en ningún acto de soborno. Inmediatamente informo los hechos a mi jefe y espero que me indique como debo de actuar.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'No acepto la propuesta porque es indignante que te pidan dinero, cuando su obligación es hacer su trabajo, en ese momento le exijo al guardia una disculpa y me retiro del lugar sin realizar la entrega ni informar a mis superiores.'
            }
        ]
    },
    {
        image: '',
        exam_id: 9,
        question_type: 5,
        question_id: 1,
        question: '¿Cuáles son y en qué orden, las actividades que tienes que realizar, con el fin de dar un excelente servicio al cliente?',
        answers: [
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '01',
                answer: `Llegar a la hora señalada por el cliente al lugar de la carga.`
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '02',
                answer: 'Presentarme con los equipos en condiciones adecuadas, tanto de limpieza como mecánicamente.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '03',
                answer: 'Estar presente y atento durante el proceso de carga y cuando las políticas del cliente lo permitan contar la mercancía.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '04',
                answer: 'Una vez concluida la carga, verificar los sellos de seguridad.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '05',
                answer: 'Realizar el traslado por la ruta señalada.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '06',
                answer: 'No detenerse en lugares no autorizados.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '07',
                answer: 'Realizar la entrega en el horario y lugar señalado por el cliente.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '08',
                answer: 'Obtener la evidencia que compruebe la correcta entrega (firma de entrega y sello por parte del cliente en la factura de TUMSA).'
            }
        ]

    },
    {
        image: '',
        exam_id: 9,
        question_type: 1,
        question_id: 1,
        question: 'Al realizar tu entrega en el lugar y horario establecido, es posible que el cliente te solicite otro tipo de servicio como: Proporcionarte otra dirección y pedirte que realices la entrega en ese otro lugar; Pedirte aunque no cuentes con ayuda de maniobristas, que tu bajes la mercancía; Solicitarte que cargues o que permitas que te carguen mercancía, para que la traslades a un nuevo destino. Ante estas solicitudes ¿Cómo debes reaccionar?',
        answers: [
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Acepto realizar lo que me pida el cliente, porque es mi obligación obedecerlo, sin importar perjudicar a mi empresa.'
            },
            {
                is_answer: true,
                answer_image: '',
                answer_if_text: '',
                answer: 'Sin exaltarme, le explico que no puedo realizar ninguno de esos trabajos y de inmediato contacto con mi jefe,  para informarle de lo que pretende el cliente y recibir sus instrucciones.'
            },
            {
                is_answer: false,
                answer_image: '',
                answer_if_text: '',
                answer: 'Le explico que no puedo realizar ninguno de esos trabajos y de inmediato me retiro del lugar. '
            }
        ]
    }
]






interface Question {
    question_id: number,
    question_type_id: number,
    image: string,
    question: string,
    answers: Answer[],
    selected: string,
    answersSet: any,
    questionsSet: any
}

interface Answer {
    id: number,
    answer: string,
    is_answer: boolean,
    selected: boolean
}


@Component({
    selector: 'app-test-sheet',
    templateUrl: './test-sheet.component.html',
    styleUrls: ['./test-sheet.component.scss']
})
export class TestSheetComponent implements OnInit, OnChanges, OnDestroy {
    questions: Question[];
    channel = this.route.snapshot.paramMap.get('testid')
    exam_name = this.route.snapshot.paramMap.get('name')

    images = environment.localstatic
    favoriteColor = ''

    constructor(private _questionnaire: QuestionnaireService,
        private route: ActivatedRoute,
        public dialog: MatDialog,
    ) { }
    ngOnDestroy(): void {

    }


    ngOnInit(): void {

        this.route.paramMap.subscribe(resolve => {
            this.channel = resolve.get('testid')
            this.exam_name = resolve.get('name')
            console.log('hello from snapshot', this.channel);
            this._questionnaire.getQuestionnaire({ exam: this.channel }).subscribe(res => {
                let questionsSet = []
                let answersSet = []
                // let answersheet = JSON.parse(sessionStorage.getItem('exam' + this.channel))
                // res.forEach(element => {
                //   if (!answersheet) { return }
                //   for (let i of answersheet[0]) {
                //     if (element.id == i.id) {
                //       element.selected = i.selected             
                //       // console.log('hello from coincidence',[element.id, i.id])
                //     } else {  }
                //   }
                // });
                this.questions = <Question[]>res
                this.questions.sort(() => Math.random() - 0.5)
                this.questions.forEach(element => {
                    element.answers.sort(() => Math.random() - 0.5)
                })
                console.log(this.questions)

                for (let question of this.questions) {
                    if (question.question_type_id == 4) {
                        for (let answer of question.answers) {
                            if (answer.is_answer == true) {
                                questionsSet.push(answer)
                            } else {
                                answersSet.push(answer)
                            }
                        }
                        question.questionsSet = questionsSet
                        question.answersSet = answersSet
                    }
                }
                //console.log(this.questionsSet)
            }).unsubscribe
        })

       /*    this._questionnaire.saveQuestionnaire(questionnaire1)
       .pipe(
           switchMap(()=>this._questionnaire.saveQuestionnaire(questionnaire2)),
           switchMap(()=>this._questionnaire.saveQuestionnaire(questionnaire3)),
           switchMap(()=>this._questionnaire.saveQuestionnaire(questionnaire4)),
           switchMap(()=>this._questionnaire.saveQuestionnaire(questionnaire5)),
           switchMap(()=>this._questionnaire.saveQuestionnaire(questionnaire6)),
           switchMap(()=>this._questionnaire.saveQuestionnaire(questionnaire7)),
           switchMap(()=>this._questionnaire.saveQuestionnaire(questionnaire8)),
           switchMap(()=>this._questionnaire.saveQuestionnaire(questionnaire9)),
           ).subscribe(console.log)   */

        /* this._questionnaire.saveQuestionnaire(questionnaire1).subscribe(res => {
            console.log('se guardaron las preguntas', res)
        }) 

        this._questionnaire.saveQuestionnaire(questionnaire2).subscribe(res => {
            console.log('se guardaron las preguntas', res)
        })

        this._questionnaire.saveQuestionnaire(questionnaire3).subscribe(res => {
            console.log('se guardaron las preguntas', res)
        })

        this._questionnaire.saveQuestionnaire(questionnaire4).subscribe(res => {
            console.log('se guardaron las preguntas', res)
        })

        this._questionnaire.saveQuestionnaire(questionnaire5).subscribe(res => {
            console.log('se guardaron las preguntas', res)
        })

        this._questionnaire.saveQuestionnaire(questionnaire8).subscribe(res => {
            console.log('se guardaron las preguntas', res)
        })
        */

    }

    ngOnChanges(changes: SimpleChanges): void {

    }

    saveExam() {

        // for (let question of this.questions) {
        //     if (question.selected != undefined) {
        //         //console.log([question.question_id, question.selected])
        //     }
        //     for (let answer of question.answers) {
        //         if (answer.selected != undefined) {
        //             //console.log(answer)
        //         }
        //     }


        // }

        sessionStorage.setItem('exam', JSON.stringify(this.questions))
        this.dialog.open(SecureDialog);


        //console.log(this.questions)
        /*  let answersheet = []
         let breakexception = [false, 0];
         this.questions.forEach((element, index) => {
           if (element.selected == undefined) {
             breakexception[0] = true
             breakexception[1] = index + 1
             return
           }
           answersheet.push({ id: Number(element.id), selected: [(element.selected)] })
         })
     
     
         sessionStorage.setItem('exam' + this.channel, JSON.stringify([answersheet, { exam: this.channel }]))
     
         */
    }

}




@Component({
    selector: 'secure_dialog',
    templateUrl: './secure_dialog.html',
    styleUrls: ['./secure_dialog.scss']

})
export class SecureDialog implements OnInit {
    constructor(
        public dialog: MatDialog,
        private _questionnaire: QuestionnaireService,
        private router: Router,

    ) { }
    sections: any;
    questions: any;
    ngOnInit() {
        this.questions = JSON.parse(sessionStorage.getItem('exam'))
        this._questionnaire.getexams({}).subscribe(resolve => {
            this.sections = resolve;
        })
    }

    sendAnswers() {



        this._questionnaire.saveResult(this.questions).subscribe(res => {
            console.log(res)
            this.saveAnswers()
        })


    }

    saveAnswers() {
        this.dialog.closeAll()
        if (this.sections[1] == undefined) {
            return this.router.navigate(['homecandidate']).then(() => {
                window.location.reload();
            }).catch(e => {
                console.log(e)
            })
        } else {
            this.router.navigate(['homecandidate/test/', this.sections[1].id, this.sections[1].name]).then(() => {
                window.location.reload();
            }).catch(e => {
                console.log(e)
            })
        }

        //sessionStorage.clear()
    }


}



